export default __webpack_public_path__ + "static/media/3.11a5e742.jpeg";